import { Queue,QueueCondition } from 'src/app/services/api/taskmanagement/taskmanagement.service';
export class QueueObject implements Queue{
    queueId: string;
    name: string;
    description: string;
    role: string;
    priority: number;
    conditions: QueueCondition[]
}
